// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d5f263f9","239":"fd74584b","732":"4354c627"}[chunkId] + ".chunk.js";
};